<script>
  import { getContext, onMount } from 'svelte'
  import { SELECTED_COLOR_KEY } from './ChromaPicker.svelte'
  
  const selectedColor = getContext(SELECTED_COLOR_KEY)

  let opacityCanvas
  let opacityCtx
  let opacityMarker

  let CANVAS_WIDTH = 300

  const createOpacityCanvas = () => {
    opacityCtx = opacityCanvas.getContext('2d') // This create a 2D context for the canvas
    opacityCtx.clearRect(0, 0, opacityCtx.canvas.width, opacityCtx.canvas.height)
    let gradientV = opacityCtx.createLinearGradient(0, 0, opacityCtx.canvas.width, 0)

    let fullOpacity = $selectedColor.rgba.replace(/rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/, 'rgba($1, $2, $3, 1)')
    gradientV.addColorStop(0, fullOpacity)

    let transparentValue = $selectedColor.rgba.replace(
      /rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/,
      'rgba($1, $2, $3, 0)'
    )
    gradientV.addColorStop(1, transparentValue)

    opacityCtx.fillStyle = gradientV
    opacityCtx.fillRect(0, 0, opacityCtx.canvas.width, opacityCtx.canvas.height)
  }

  const handleOpacityClick = event => {
    const canvasDimensions = opacityCanvas.getBoundingClientRect()
    const maxX = CANVAS_WIDTH - opacityMarker.clientWidth
    const x = event.clientX - canvasDimensions.left <= maxX ? event.clientX - canvasDimensions.left : maxX

    let opacity = 1 - x / maxX
    opacity = Math.round(opacity * 100)

    selectedColor.change({ opacity }, $selectedColor)

    opacityMarker.style.left = `${x}px`
  }

  const positionMarker = () => {
    const maxX = opacityCanvas.width - opacityMarker.clientWidth

    const x = ((100 - $selectedColor.opacity) / 100) * maxX

    opacityMarker.style.left = `${x}px`
  }

  $: if ($selectedColor && opacityCanvas) {
    positionMarker()
    createOpacityCanvas()
  }

  onMount(() => {
    createOpacityCanvas()
  })
</script>

<canvas
  width="{CANVAS_WIDTH}px"
  height="25px"
  id="opacity_canvas"
  class="canvas"
  bind:this={opacityCanvas}
  on:click={e => handleOpacityClick(e)}
/>
<div id="opacity_marker" class="marker" bind:this={opacityMarker} />

<style>
  #opacity_canvas {
    background-image: repeating-linear-gradient(
        45deg,
        #000000 25%,
        transparent 25%,
        transparent 75%,
        #000000 75%,
        #000000
      ),
      repeating-linear-gradient(45deg, #000000 25%, #e5e5f7 25%, #e5e5f7 75%, #000000 75%, #000000);
    background-position: 0 0, 10px 10px;
    background-size: 20px 20px;
  }

  /* tests do not work without this */
  #opacity_marker {
    position: relative;
    height: 25px;
    width: 25px;
    border: 1px solid white;
    top: 0px;
  }
</style>
